import React, { Component } from 'react';
import { connect } from "react-redux";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { bindActionCreators } from 'redux';

import * as actions from "../../actions/ordersAction";
import * as compressionAction from '../../actions/compressionAction';
import * as symbols from "../../operations/symbols";
import { PhotoMainViewer } from '../core/PhotoViewerComponent';
import PictureModeModal from '../core/PictureModeModal';
import LoaderComponent from '../core/LoaderComponent';
import { fetchAppConfig } from './../../actions/appConfigActions';
import NoLocationFound from './NoLocationFound/NoLocationFound';


const IMAGE_TYPE_FIELD_MAP = {
  store_image: 'storeImages',
  invoice: 'invoiceImages'
}

const NO_LOCATION_BUTTON_TEXT_MAP = {
  store_image: 'Go to upload store image',
  invoice: 'Go to upload invoice'
}

class MultiImageUploaderComponent extends Component {

  constructor(props) {
    super(props);

    this.state = {
      selectedImages: [],
      geoLocationInProgress: false,
      fetchLocation: true
    }
  }

  openPictureModeModal() {
    this.setState({ openPictureModeModal: true })
  }

  closePictureModeModal() {
    this.setState({ openPictureModeModal: false })
  }

  componentDidMount() {
    const { imageType, isLocationEnabled } = this.props;
    const { selectedImages = [] } = this.props;
    if(isLocationEnabled === "") {
      this.props.actions.fetchAppConfig();
    }
    if (selectedImages.length !== 0) {
      this.props.actions.compressImagesAction(selectedImages, IMAGE_TYPE_FIELD_MAP[imageType]);
      if(isLocationEnabled && imageType !== "invoice") {
        this.addGeolocationAndUpload();
      }
    }
  }

  // show disable button when compression is in progress
  // show disable button with spinner when uploading or geolocation fetch is in progress
  // else show green button
  getUploadButton() {
    if (this.props.uploadImagesStatus === symbols.STATUS_BEGIN || this.state.geoLocationInProgress === true
    ) {
      return (<div className="btn btn-expand btn-disabled"><FontAwesomeIcon icon="spinner" className="animate-spinner" /></div>)
    } else if (this.props.imageCompressionStatus === symbols.STATUS_BEGIN || (this.props.uploadedImages.length === 0 && this.props.compressedImages.length === 0 && this.props.selectedImages.length === 0)) {
      return (<div className="btn btn-expand btn-disabled">{this.props.uploadButtonText}</div>)
    } else {
      return (<div className="btn btn-green btn-expand" onClick={() => this.onButtonClick()}>{this.props.uploadButtonText}</div>)
    }
  }

  // file handler - compress the images, images will be set in state upon component update
  setImages(files) {
    const { fetchLocation } = this.state;
    const { isLocationEnabled, imageType } = this.props;
    this.closePictureModeModal();
    this.props.actions.setOrderDetailImages(this.props.orderId, files, this.props.imageType); 
      this.props.actions.compressImagesAction(files);
      if (files.length === 1 && fetchLocation && isLocationEnabled && imageType !== "invoice") {
        this.addGeolocationAndUpload();
    }
  }

  removeImage(e, currIndex) {
    this.props.actions.removeImageAction(currIndex);
  }

  onButtonClick() {
    const { latitude, longitude, fetchLocation } = this.state;
    const { isLocationEnabled, selectedImages, compressedImages, imageType } = this.props;
    const photosToUpload = compressedImages && compressedImages.length ? compressedImages : selectedImages;
    if (photosToUpload && photosToUpload.length > 0) {
      let payload = new FormData();
      if (photosToUpload === 1) {
        payload.append('files', photosToUpload[0]);
      } else {
        for (let i = 0; i < photosToUpload.length; i++) {
          payload.append('files', photosToUpload[i]);
        }
      }
      if (fetchLocation && isLocationEnabled && imageType !== "invoice" ) {
        if (latitude && longitude) {
          payload.append('latitude', latitude);
          payload.append('longitude', longitude);
          payload.append('imageType', this.props.imageType);
          payload.append('uncompressed_images', compressedImages && compressedImages.length !== 0 ? false : true);
          this.props.onSubmit(payload);
        } else {
          this.addGeolocationAndUpload(payload, true);
        }
      } else {
        payload.append('imageType', this.props.imageType);
        payload.append('uncompressed_images', compressedImages && compressedImages.length !== 0 ? false : true);
        this.props.onSubmit(payload);
      }


    } else if (this.props.uploadedImages.length > 0) {
      this.props.onSkipUpload();
    }
  }

  addGeolocationAndUpload = (payload, doFetchAndUpload) => {
    this.setState({ geoLocationInProgress: true })
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition((location) => this.onSuccess(location, payload, doFetchAndUpload), (error) => this.onError(error, payload, doFetchAndUpload), { timeout: 5000 });
    }
  }

  onSuccess = (location, payload, doFetchAndUpload) => {
    const longitude = location.coords.longitude;
    const latitude = location.coords.latitude;
    if (doFetchAndUpload) {
      payload.append('latitude', latitude);
      payload.append('longitude', longitude);
      payload.append('imageType', this.props.imageType);
      this.props.onSubmit(payload);
    }
    this.setState({ geoLocationInProgress: false, latitude: latitude, longitude: longitude });
  }

  onError = (error, payload, doFetchAndUpload) => {
    const code = error.code;
    if (code === 1) {
      this.setState({ isLocationOff: true });
    }
    if (code === 3) {
      // If browser is unable to fetch any information about location then send without lat and lon
      if (doFetchAndUpload) {
        payload.append('imageType', this.props.imageType);
        this.props.onSubmit(payload);
      }
      this.setState({ fetchLocation: false });
    }
    this.setState({ geoLocationInProgress: false })
  }

  hideLocationModal = () => {
    this.setState({ isLocationOff: false })
  }

  getNoLocationButtonText = () => {
    return NO_LOCATION_BUTTON_TEXT_MAP[this.props.imageType]
  }

  render() {
    const {
      openPictureModeModal,
      isLocationOff,
    } = this.state;

    const { getOrdersStatus, uploadedImages } = this.props;

    let clickedImages = this.props.compressedImages && this.props.compressedImages.length ? this.props.compressedImages : this.props.selectedImages;
    return (
      <div>
        {/*Open modal for picture click*/}
        <PictureModeModal
          isOpen={openPictureModeModal}
          closePictureModeModal={() => this.closePictureModeModal()}
          hasSameRoute={true}
          default={true}
          hasNotWrapper={true}
          setImages={(files) => this.setImages(files)}
        />
        <NoLocationFound isOpen={isLocationOff} hideLocationModal={this.hideLocationModal} buttonText={this.getNoLocationButtonText()} />
        <div className="order-top-header fs-14">
          <div className="subtitle">
            <b>{this.props.uploadButtonText}</b>
          </div>
          {
            getOrdersStatus === symbols.STATUS_BEGIN ?
              <LoaderComponent /> : null
          }
          {
            uploadedImages
            && uploadedImages.length > 0 &&
            <div className="order-photos ">
              <PhotoMainViewer
                parentClass="order-photo-wrapper"
                className="order-photo-ele "
                photos={uploadedImages}
                id={this.props.orderId}
              />
            </div>
          }
          <div className="order-photos mt-2">
            <div className="horizontal-scroll">

              <div className="order-photo-wrapper">
                <div
                  className="gallery-item order-photo-ele order-photo-placeholder"
                  onClick={() => this.openPictureModeModal()}
                >
                  <FontAwesomeIcon icon="camera" />
                </div>
              </div>
              {
                clickedImages && clickedImages.length !== 0 && clickedImages.map((ele, index) => {
                  return (
                    <div className="order-photo-wrapper">
                      <div className="cross-image" onClick={(e) => this.removeImage(e, index)}>
                        <FontAwesomeIcon icon="times" />
                      </div>
                      <div className={`gallery-item order-photo-ele`} style={{ 'backgroundImage': 'url(' + URL.createObjectURL(ele) + ')' }}></div>
                    </div>
                  )
                })
              }
            </div>
            <div className="fixed-verify-section z-index-5 order-card">
              {
                <React.Fragment>
                  {this.getUploadButton()}
                </React.Fragment>
              }
            </div>
            {
              this.props.uploadImagesStatus === symbols.STATUS_FAIL && this.props.uploadImagesError && <div className="red-text mt-2">{this.props.uploadImagesError.error.message}</div>
            }
    
          </div>
        </div>
      </div>
    )
  }
}

export default connect(
  state => ({
    getOrdersStatus: state.statuses.getOrderDetails.status,
    getOrdersError: state.statuses.getOrderDetails.error,
    uploadImagesStatus: state.statuses.uploadImages.status,
    uploadImagesError: state.statuses.uploadImages.errors,
    imageCompressionStatus: state.statuses.imageCompression.status,
    imageCompressionError: state.statuses.imageCompression.error,
    compressedImages: state.compressedImages.compressedImages || [],
    orders: state.orders,
    isLocationEnabled: state.appConfig.is_location_enabled || ""
  }),
  dispatch => ({
    actions: bindActionCreators({
      ...actions, ...compressionAction, fetchAppConfig
    }, dispatch),
  }),
)(MultiImageUploaderComponent);
